/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class NotificationsService {
  /**
   * 📱 Mark a notification as read
   * @param id ID of the notification to mark as read
   * @returns any OK
   * @throws ApiError
   */
  public static markNotificationAsRead(id: string): CancelablePromise<{
    data?: {
      message?: string
    }
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/notifications/{id}/mark-as-read',
      path: {
        id: id,
      },
      errors: {
        401: `The request was unauthenticated`,
        404: `The requested resource was not found`,
      },
    })
  }
}
